export default __webpack_public_path__ + "static/media/pictogramBeaconInsurance64.5caeb9c2.svg";